import type React from 'react';

const HelpScoutIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.152 13.7038L10.8073 7.8519C11.5404 7.10536 11.9942 6.0578 11.9942 4.91391C11.9942 3.78206 11.552 2.74654 10.8422 2L5.18691 7.8519C4.45382 8.59843 4 9.646 4 10.7899C4 11.9338 4.44218 12.9573 5.152 13.7038ZM18.848 10.2842L13.1927 16.1361C12.4596 16.8826 12.0058 17.9302 12.0058 19.0741C12.0058 20.2059 12.448 21.2414 13.1578 21.988L18.8131 16.1361C19.5462 15.3895 20 14.342 20 13.1981C20 12.0542 19.5578 11.0307 18.848 10.2842ZM18.8131 7.86394C19.5462 7.1174 20 6.06984 20 4.92595C20 3.7941 19.5578 2.75858 18.848 2.01204L5.18691 16.1361C4.45382 16.8946 4 17.9302 4 19.0861C4 20.2179 4.44218 21.2535 5.152 22L18.8131 7.86394Z"
      fill="#1292EE"
    />
  </svg>
);

export default HelpScoutIcon;
